import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useTinCheckReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useTinCheckReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: useTinCheckReRunMutationProps) =>
			autoChecklistService.reRunTINCheck(id),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "TIN Check re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useTinCheckReRunMutation;
